import PropTypes from 'prop-types';
import React from 'react';
import { map } from 'lodash';

import NavigationItem from './NavigationItem';

const Navigation = ({ routes }) => (
  <nav className="tvt-header__navigation">
    <ul className="tvt-header__navigation-list">
      {map(routes, route => (
        <NavigationItem key={route.id} {...route} />
      ))}
    </ul>
  </nav>
);

Navigation.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      id: PropTypes.string,
      isMenu: PropTypes.bool,
      label: PropTypes.string,
      path: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(
          PropTypes.shape({
            path: PropTypes.string,
            label: PropTypes.string
          })
        )
      ])
    })
  ).isRequired
};

export default Navigation;
